<template lang="html">
    <div class="main-container">

         <breadcrumb
          :list="breadcrumbList"/>
          <div class="margintop-32" />
        <tl-tabs  :tabs="[{header:'Form 16'},{header:'Employee list'}]">

            <tl-tab>
        <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
          You have only view permission.
        </div>
        <div class="rectangle">
            <label class="upload-digitally-sig">
                <span class="info-icon">i</span>
                Upload digitally signed form 16. Signature can be done on all the pages or the alternate pages or odd/even pages.
            </label>
        </div>

        <!-- <div class="row margin-top-27">
            <tl-radio name="fileType" class="col-3 " label="Consolidated Folder" id="consolidatedFolder" value="consolidatedFolder" v-model="fileType_isConsolidated"
            />
            <tl-radio name="fileType" class="col-3 " label="Separate Files" id="seperateFiles" value="seperateFiles" v-model="fileType_isConsolidated"
            />
        </div> -->

        <div >
        <!-- v-if="fileType_isConsolidated == 'consolidatedFolder'"> -->


              <tl-select
                   label="Merged Forms"
                   class="margin-top-10"
                  :value="MergeType"
                  :options="['Individual Files','Form A & Form B Merged','All Three Form Merged']"
                  @change="(val)=>changeType(val)"
                  :disabled="!ifTeamleaderAnchorPermission"
                  />
            <div class="margin-top-25 row">
                <div class="col-4"  v-show="MergeType=='Individual Files' || MergeType=='Form A & Form B Merged' || MergeType=='All Three Form Merged'">
                  <span class="label-text" v-show="MergeType=='Individual Files'"><b>Part A</b></span>
                  <span class="label-text" v-show="MergeType=='Form A & Form B Merged'"><b>Merged Part A and B </b></span>
                  <span class="label-text" v-show="MergeType=='All Three Form Merged'"><b>All Three Merged </b></span>
                  <upload name="parta" :tobucket="false" @change="onFileChange($event,'partA')" :status="statusA"></upload>
                </div>
                 <div class="col-4"  v-show="MergeType=='Individual Files'">
                  <span class="label-text"><b>Part B</b></span>
                  <upload name="partb" :tobucket="false" @change="onFileChange($event,'partB')" :status="statusB"></upload>
                </div>
            </div>
             <div class="margin-top-25 row" v-show="MergeType=='Individual Files'|| MergeType=='Form A & Form B Merged'">
                 <div class="col-4">
                  <span class="label-text"><b>Annexure</b></span>
                  <upload name="annex" :tobucket="false" @change="onFileChange($event,'annexure')" :status="statusAnnex"></upload>
                  <div class="margin-top-38">
                    <a class="click-here-btn" @click="clickHereToDownload">Download Annexure </a>
                    <label class="download-text"> from server</label>
                </div>
                  </div>
                </div>

            <div class="margin-top-25">
              <div v-show="MergeType=='Individual Files'">
                <tl-checkbox class="margin-top-18" label="Merge Forms" name="merge" id="merge" v-model="mergeRequest"
                />
                <tl-select
                   label="Merged Forms"
                   class="margin-top-10"
                  v-if="mergeRequest"
                  :value="MergerType"
                  :options="['Merge Part A, Part B & Annexure','Merge Part A & Part B']"
                  @change="(val)=>changeRequest(val)"
                  />
                  </div>
                <!-- <tl-checkbox class="margin-top-18" label="Apply Digial Signature" name="digsig" id="digsig" v-model="consolidatedChecksData.publishForm16"
                /> -->
               <tl-checkbox class="margin-top-18" label="Publish Form 16 in ESS" name="form16ess" id="form16ess"
                    v-model="publish_form_16_ess" :disabled="!ifTeamleaderAnchorPermission"/>
            </div>


        </div>
        <bottom-action-container >
            <template slot="end">
                <btn-grp>
                    <btn text="Back" type="secondary" @click="routeToSubStep" />
                    <btn text="Upload" type="primary" @click="submit" :disabled="!ifTeamleaderAnchorPermission"/>
                </btn-grp>
            </template>
        </bottom-action-container>

        <pop-up-message v-if="showSuccessMsg" :closable="true" message="Files submitted successfully" popupHeaderMessage="Success." btnText="Ok" @back="backfrompopup()">
        <template v-slot:bottomContent>
  <div class="popup-btn-group">
    <button class="btn-popup" type="button" @click="backfrompopup()">Back to Form 16</button>
  </div>
  </template>
        </pop-up-message>
      </tl-tab>
    <tl-tab>
      <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
          You have only view permission.
      </div>
        <div>
          <div class="margin-top-45">
                <div class="paygrpsDiv">
                    <div class="alignPaygrp">
                        <span> Total Employee </span>
                        <br>
                        <div class="paygrps-info">
                            <b> {{employeeData.length}} </b>
                        </div>
                    </div>

                    <div class="alignPaygrp">
                        <span> Merged Files </span>
                        <br>
                        <div class="paygrps-info">
                            <b> {{totalCount}} </b>
                        </div>
                    </div>
                    <div class="alignPaygrp">
                        <span> Part A </span>
                        <br>
                        <div class="paygrps-info">
                            <b>{{partACount}}</b>
                        </div>
                    </div>
                    <div class="alignPaygrp">
                        <span> Part B </span>
                        <br>
                        <div class="paygrps-info">
                            <b>{{partBCount}}</b>
                        </div>
                    </div>
                    <div class="alignPaygrp">
                        <span> Annexure </span>
                        <br>
                        <div class="paygrps-info">
                            <b>{{annexureCount}}</b>
                        </div>
                    </div>
                    <div class="alignPaygrp">
                        <span> File Mismatch </span>
                        <br>
                        <div class="paygrps-info">
                            <b>{{misMatch}}</b>
                        </div>
                    </div>
                </div>
            </div>

            <!-- data table will be below -->
            <!-- <div>{{employeeData.length}}&nbsp;/&nbsp;{{totalEmployees}}</div> -->
            <div class="table-div" ref="table_div" :disabled="!ifTeamleaderAnchorPermission">
              <data-table
                :columns="employeeTableColumns"
                :tableData="employeeData"
                :showinrow="true"
                :with-form="false"
                :showhistory="false"
                :showdelete="false"
                :showedit="false"
              >
                 <template v-slot:rowcontent="slotprops">
            <img class="sm-img" v-if="slotprops.value.column.key=='imgSrc'" :src="slotprops.value.record[slotprops.value.column.key]"
            />
            <p v-if="slotprops.value.column.key!='imgSrc' && slotprops.value.column.key!='LegalEntityForm24Q'  && slotprops.value.column.key !='form16_part_A_file' && slotprops.value.column.key !='form16_part_B_file' && slotprops.value.column.key !='form16_annexure_file' && slotprops.value.column.key !='form16_file' && slotprops.value.column.key !='fileType'">{{slotprops.value.record[slotprops.value.column.key]}}</p>
            <div v-if="slotprops.value.column.key=='form16_part_A_file' && slotprops.value.record[slotprops.value.column.key]!=null">

                <a class="file-name input-label attachment" :href="slotprops.value.record[slotprops.value.column.key]" target="blank" download=true>
                  <img  class="atch-img" :src="require('@/assets/checked01.svg')" /></a>
            </div>
            <div v-if="slotprops.value.column.key=='form16_part_B_file' && slotprops.value.record[slotprops.value.column.key]!=null">

                <a class="file-name input-label attachment" :href="slotprops.value.record[slotprops.value.column.key]" target="blank" download=true>
                  <img  class="atch-img" :src="require('@/assets/checked01.svg')" /></a>
            </div>
            <div v-if="slotprops.value.column.key=='form16_annexure_file' && slotprops.value.record[slotprops.value.column.key]!=null">

                <a class="file-name input-label attachment" :href="slotprops.value.record[slotprops.value.column.key]" target="blank" download=true>
                  <img  class="atch-img" :src="require('@/assets/checked01.svg')" /></a>
            </div>
            <div v-if="slotprops.value.column.key=='form16_file' && slotprops.value.record[slotprops.value.column.key]!=null">

                <a class="file-name input-label attachment" :href="slotprops.value.record[slotprops.value.column.key]" target="blank" download=true>
                  <img  class="atch-img" :src="require('@/assets/checked02.svg')" />Merged</a>
            </div>
            <div v-if="slotprops.value.column.key=='fileType'">
              <span>
                <label class="file-type-label">
                  {{slotprops.value.record[slotprops.value.column.key]}}
                </label>
              </span>
            </div>
            <!-- <div v-if="slotprops.value.column.key=='LegalEntityForm24Q'"> -->
              <p>{{slotprops.value.record[slotprops.value.column.key] ? slotprops.value.record[slotprops.value.column.key].quarter : ""}}</p>
            <!-- </div> -->

               </template>
              </data-table>
            </div>
            <div>

            </div>
        </div>
        </tl-tab>
     </tl-tabs>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "form16",
  uploadFailed: false,
  computed: {
    ...mapState({}),
    ...mapGetters({
      orgid: "onboard/organization/orgid",
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.form_16Value) {
            return true;
          } else {
            return false;
          }
        } 
        // else {
        // return true 
        // }
    }
  },
  data() {
    return {
      showToastMessage: false,
      showSuccessMsg: false,
      MergeType:'',
      already_merged_A_B:false,
		  already_merged_All:false,
      fileType_isConsolidated: "consolidatedFolder",
      publish_form_16_ess:false,
      mergeRequest:false,
      MergerType:'',
      merge_A_B: false,
		  merge_A_B_ANNEXURE: false,
      consolidatedChecksData: {
        emailForm16: false,
        publishForm16: false,
        passwordProtectFiles: false
      },
      seperateFilesChecksData: {
        mergePartAB: false,
        emailForm16: false,
        publishForm16: false,
        passwordProtectFiles: false,
        lockForm16: false
      },
      statusA: 0,
      statusB: 0,
      statusAnnex: 0,
      files: new FormData(),
      totalEmployees: 0,
      form16List: [],
      employeeData: [],
      totalCount:0,
      partACount:0,
      partBCount:0,
      annexureCount:0,
      misMatch:0,
      employeeTableColumns: [
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },

        {
          label: "Pan Number",
          key: "pan_number"
        },
        {
          label: "Form 16A",
          key: "form16_part_A_file"
        },
        {
          label: "Form 16B",
          key: "form16_part_B_file"
        },
        {
          label: "Annexure",
          key: "form16_annexure_file"
        },
        {
          label: "Merged Files",
          key: "form16_file"
        }

      ],

      // fileName: "foem16_may_2019",
     breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
        },
        {
          name: "Form 16",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/form16`
        }
      ],
      form_16Value: false,
      role: ""
    };
  },
  mounted() {
    this.fetchData();
    this.getOrgLeIdList();
  },
  activated() {
  //   this.fetchData();
    this.getOrgLeIdList();
  },

  methods: {
    ...mapActions({
      uploaddocs: "dashboard/payroll/utilities/form16/create",
      getform16: "dashboard/payroll/utilities/form16/getForm16",
      act_fetch: "onboard/employees/fetchAll",
    }),
    routeToSubStep() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
      });
    },
    routeToMainStep() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation`
      });
    },

   async fetchData(){
      let res = await this.getform16(this.le_id);
      //console.log("this is response ",res);
      this.form16List=res.data.payload.data;
      this.fetchemp();
    },
    async fetchemp() {
      try {
        let res = await this.act_fetch({ le_id: this.le_id, page: this.page });
        //console.log("res data",res);
        if (res.data.status) {
          let empList = [];
          this.totalEmployees = res.data.payload.totalEmpCount;
          res.data.payload.data.forEach(element => {
            empList.push({
              id: element.id,
              name:
                element.first_name +
                " " +
                (element.last_name ? element.last_name : ""),
              code: element.code,
              pan_number:element.pan_number,
              // location: element.EmployeeOfficial
              //   ? this.getLocationName(element)
              //   : "",   // PL_3031
              // designation: element.EmployeeOfficial
              //   ? this.getDesignationName(element)
              //   : ""    // PL_3031
              form16_part_A_file:this.getForm16DataA(element),
              form16_part_B_file:this.getForm16DataB(element),
              form16_annexure_file:this.getForm16DataAnnexure(element),
              form16_file:this.getForm16Data(element),


            });
          });
          this.employeeData.push(...empList);
          this.viewMore();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
      getForm16DataA(element){
        let form16PartA = this.form16List.find(item => {
          if(item.employee_id==element.id) return item
          else return null
      });
      if(form16PartA==undefined) return null
      else return form16PartA.form16_part_A_file
      },
      getForm16DataB(element){
        let form16PartB = this.form16List.find(item => {
          if(item.employee_id==element.id) return item
          else return null
      });
      if(form16PartB==undefined) return null
      else return form16PartB.form16_part_B_file
      },
      getForm16DataAnnexure(element){
         let form16Annexure = this.form16List.find(item => {
          if(item.employee_id==element.id) return item
          else return null
      });
      if(form16Annexure==undefined) return null
      else return form16Annexure.form16_annexure_file
      },
      getForm16Data(element){
        let form16 = this.form16List.find(item => {
          if(item.employee_id==element.id) return item
          else return null
      });
      if(form16==undefined) return null
      else return form16.form16_file
      },

    clickHereToDownload() {},

    viewMore() {
      this.misMatch=0;
       //console.log("this is emp data",this.employeeData);
       for(let i=0;i<=this.employeeData.length;i++){
          if (this.employeeData[i].form16_file!=null)
              this.totalCount++;
          if(this.employeeData[i].form16_part_A_file!=null)
             this.partACount++;
          if(this.employeeData[i].form16_part_B_file!=null)
             this.partBCount++;
          if(this.employeeData[i].form16_annexure_file!=null)
             this.annexureCount++;
       }
    },

    backfrompopup() {

      this.showSuccessMsg = false;
       window.location.reload();
       this.fetchData();
    },
    async onFileChange(event, form) {
      try {
        //console.log("data", form);
        //console.log(event);
        // this.files = new FormData();
        // let fileData={}
        // fileData.append("name", event.name);
        // fileData.append("file", event);
        if (form == "partA") {
          this.statusA = 2;
          this.files.append("files", event);
        }
        if (form == "partB") {
          this.statusB = 2;
          this.files.append("files", event);
        }
        if (form == "annexure") {
          this.statusAnnex = 2;
          this.files.append("files", event);
        }
        // this.status = 1;
        // this.act_fileUpload([this.fileData, this.le_id]);
        // this.status = 2;
        // alert('success');
        // this.files={...this.fileData}
      } catch (error) {
        //console.log(error);
        this.errmsg = error;
        this.toast = true;
      }
    },
    async submit() {
      try {
        //console.log("publish_form_16_ess", this.publish_form_16_ess);

        // const obj = {
        //   publish_form_16_ess: this.publish_form_16_ess
        // };
        // const json = JSON.stringify(obj);
        // const blob = new Blob([json], {
        //   type: "application/json"
        // });already_merged_A_B:false,
		  ///already_merged_All:false,
        this.files.append("publish_form_16_ess", this.publish_form_16_ess);
        this.files.append("already_merged_A_B", this.already_merged_A_B);
        this.files.append("already_merged_All", this.already_merged_All);
        this.files.append("merge_A_B", this.merge_A_B);
        this.files.append("merge_A_B_ANNEXURE", this.merge_A_B_ANNEXURE);
        this.files.append("le_id",this.le_id);
        let res = await this.uploaddocs(this.files);
        if (res.status) this.showSuccessMsg = true;
      } catch (err) {
        //console.log(err);
      }
      // this.showToastMessage = true;
      // if (this.fileType_isConsolidated == 'consolidatedFolder') {
      //     if (!(this.consolidatedChecksData.emailForm16 || this.consolidatedChecksData.publishForm16 || this.consolidatedChecksData.passwordProtectFiles)) {

      //     }
      // } else {
      //     if (!(this.seperateFilesChecksData.mergePartAB ||  this.seperateFilesChecksData.emailForm16 || this.seperateFilesChecksData.publishForm16 || this.seperateFilesChecksData.passwordProtectFiles)) {

      //     }
      // }

      // this.showSuccessMsg = true;
    },
    changeType(val) {
      this.MergeType = val;
      if(this.MergeType=='Individual Files'){
        this.already_merged_A_B=false;
		    this.already_merged_All=false;
      }else if(this.MergeType=='Form A & Form B Merged'){
          this.already_merged_A_B=true;
		      this.already_merged_All=false;
      }else if(this.MergeType=='All Three Form Merged'){
        this.already_merged_A_B=false;
		    this.already_merged_All=true;
      }else{
        //console.log("something is wrong");
      }
    },
    changeRequest(val){
      //'Merge Part A, Part B & Annexure','Merge Part A & Part B'
      this.MergerType = val;
      if(this.MergerType=='Merge Part A, Part B & Annexure'){
        this.merge_A_B_ANNEXURE=true;
      }else if(this.MergerType=='Merge Part A & Part B'){
        this.merge_A_B=true;
      }else{
        //console.log("something is wrong")
           this.merge_A_B_ANNEXURE=true;
           this.merge_A_B=true;

      }
      //console.log("check value",this.merge_A_B_ANNEXURE);
    },

    ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgId;
        const le = this.le_id;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.form_16Value = data.data.user.permissions.form_16 ? true : false;
        //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";  //margins
.margin-top-3 {
  margin-top: 3%;
}

.margin-top-15 {
  margin-top: 1.5%;
}

.margin-top-27 {
  margin-top: 2.7%;
}

.margin-top-45 {
  margin-top: 45px;
}

.margin-top-21 {
  margin-top: 2.1%;
}

.margin-top-38 {
  margin-top: 3.8%;
}

.margin-top-8 {
  margin-top: 8px;
}

.margin-top-25 {
  margin-top: 2.5%;
}

.margin-top-18 {
  margin-top: 18px;
}

.margin-top-10 {
  margin-top: 10px;
}

.margin-top-16 {
  margin-top: 1.6%;
}

.header.header3 {
  padding-bottom: 0px;
}

.rectangle {
  height: 50px;
  border-radius: 4px;
  background-color: #f9f9f9;
  padding: 15px 30px;
}

.upload-digitally-sig {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #646464;
}

.download-text {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #b3b3b3;
}

.click-here-btn {
  color: #5d409f;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  cursor: pointer;
  text-decoration: underline;
}

.view-more-btn {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #5d409f;
  cursor: pointer;
  text-decoration: underline;
}

.view-more-box {
  padding-left: 50px;
}

.upload {
  width: 316px;
}

.errorBox {
  height: 50px;
  border-radius: 2px;
  background-color: #fbfbfb;
  padding: 15px 30px;
}

.error-text {
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #646464;
}

.part-text {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.85);
}

.upload-failed-fileName-text {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #646464;
}

.upload-failed {
  font-size: 12px;
  color: #9c9c9c;
}

.upload-failed-boxes {
  height: 50px;
  padding: 8px 50px;
}

.paygrpsDiv {
  display: flex;
  cursor: pointer;
  grid-template-columns: repeat(4/2fr);
  grid-template-rows: auto;
  grid-gap: 2px;

  span {
    color: #646464;
    font-size: 16px;
  }
}

.paygrps-info {
  margin-top: 13px;
  color: #646464;
  cursor: pointer;
  text-align: center;
  b {
    font-size: 24px;
    font-weight: 600;
    color: #646464;
  }
}

.alignPaygrp {
  margin-right: 10%;
}

.error-img {
  height: 15px;
  position: relative;
  padding-right: 5px;
  width: 30px;
  top: 2px;
}

.info-icon {
  border: 1px #646464 solid;
  border-radius: 100%;
  width: 20px;
  height: 20px;
  margin: 0 5px 0 0;
  display: inline-block;
  vertical-align: middle;
  font-size: 15px;
  color: #646464;
}

.padding-right-15 {
  padding-right: 15px;
}
.footer-width {
  width: 87%;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
